import React from "react";
import { BRAND_COLOR } from "../../common/constants";

import registerBookImg from "../../assets/register-book.png";
import joinMeetingImg from "../../assets/join-meeting.png";
import oneToOneImg from "../../assets/one-to-one.png";
import practiceImg from "../../assets/practice.png";

const steps = [
  {
    title: "Register & Book",
    subtitle: "Get started easily",
    description:
      "Register on Speak Bold with KK and book a live session from the timetable at a time that suits you. Become part of a supportive speaking community.",
    icon: "📝",
    image: registerBookImg,
  },
  {
    title: "Join the Meeting",
    subtitle: "Host-guided sessions",
    description:
      "When it’s time, return to the timetable and click the Enter button. The host welcomes you and explains the session flow.",
    icon: "🎥",
    image: joinMeetingImg,
  },
  {
    title: "1-on-1 Conversation",
    subtitle: "Practice with a partner",
    description:
      "You’ll have two rounds of 15-minute conversations with another participant using guided questions provided by the host.",
    icon: "🗣️",
    image: oneToOneImg,
  },
  {
    title: "Practice & Improve",
    subtitle: "Build real confidence",
    description:
      "Practice regularly, receive feedback, and steadily improve your communication confidence in real-life situations.",
    icon: "🚀",
    image: practiceImg,
  },
];

const HowItWorks = () => {
  const isMobile = window.innerWidth <= 768;

  return (
    <section
      id="how-it-works"
      style={{
        width: "100%",
        padding: isMobile ? "50px 16px" : "80px 20px",
        backgroundColor: "#f9faff",
      }}
    >
      {/* ===== HEADER ===== */}
      <div style={{ textAlign: "center", marginBottom: isMobile ? 40 : 60 }}>
        <h2
          style={{
            fontSize: isMobile ? 26 : 36,
            marginBottom: 10,
            color: BRAND_COLOR,
          }}
        >
          How Does It Work?
        </h2>

        <p
          style={{
            fontSize: isMobile ? 15 : 17,
            color: "#555",
            maxWidth: 700,
            margin: "0 auto",
            lineHeight: 1.5,
          }}
        >
          A simple and effective process designed to help you speak confidently
          and fluently.
        </p>
      </div>

      {/* ===== CARDS ===== */}
      <div
        style={{
          maxWidth: 1300,
          margin: "0 auto",
          display: "grid",
          gridTemplateColumns: isMobile
            ? "1fr"
            : "repeat(auto-fit, minmax(260px, 1fr))",
          gap: isMobile ? 18 : 24,
        }}
      >
        {steps.map((step, index) => (
          <div
            key={index}
            style={{
              backgroundColor: "#fff",
              borderRadius: 14,
              overflow: "hidden",
              boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
              transition: isMobile ? "none" : "transform 0.3s ease",
            }}
            onMouseEnter={(e) => {
              if (!isMobile)
                e.currentTarget.style.transform = "translateY(-6px)";
            }}
            onMouseLeave={(e) => {
              if (!isMobile)
                e.currentTarget.style.transform = "translateY(0)";
            }}
          >
            {/* ===== IMAGE ===== */}
            <div
              style={{
                height: isMobile ? 160 : 190,
                width: "100%",
                overflow: "hidden",
              }}
            >
              <img
                src={step.image}
                alt={step.title}
                loading="lazy"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </div>

            {/* ===== CONTENT ===== */}
            <div style={{ padding: isMobile ? 16 : 20 }}>
              <div
                style={{
                  fontSize: isMobile ? 24 : 28,
                  marginBottom: 8,
                }}
              >
                {step.icon}
              </div>

              <h3
                style={{
                  fontSize: isMobile ? 18 : 20,
                  marginBottom: 4,
                  color: "#222",
                }}
              >
                {step.title}
              </h3>

              <p
                style={{
                  fontSize: isMobile ? 15 : 18,
                  fontWeight: 600,
                  color: BRAND_COLOR,
                  marginBottom: 8,
                }}
              >
                {step.subtitle}
              </p>

              <p
                style={{
                  fontSize: isMobile ? 14.5 : 17,
                  color: "#555",
                  lineHeight: 1.55,
                }}
              >
                {step.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HowItWorks;
